function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import './styles.css';
import { MainGreen, Opacity_16 } from '../../utils/colors';
export default function AudioLevelIndicator(_ref) {
  var volume = _ref.volume;
  var baseHeight = window.screen.width < 600 ? 8 : 12;
  var fullStyle = {
    backgroundColor: MainGreen
  };

  var getBarStyle = function getBarStyle(barHeight, volumeValue) {
    if (volumeValue === void 0) {
      volumeValue = 0;
    }

    return _extends({
      height: barHeight + "px",
      backgroundColor: Opacity_16
    }, volume > volumeValue ? fullStyle : '');
  };

  var renderBar = function renderBar(barHeight, volumeValue) {
    if (volumeValue === void 0) {
      volumeValue = 0;
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "audio-level__indicator " + (volume > 0 ? 'audio-level__indicator--full' : ''),
      style: getBarStyle(barHeight, volumeValue)
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "audio-level"
  }, renderBar(baseHeight, 0), renderBar(baseHeight * 1.5, 7), renderBar(baseHeight * 2, 14));
}